import { render, staticRenderFns } from "./resource-folder-restrictor.vue?vue&type=template&id=55dbeb0a"
import script from "./resource-folder-restrictor.vue?vue&type=script&lang=ts"
export * from "./resource-folder-restrictor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports